<script lang="ts">
	import { cn } from 'tailwind-variants'

	import { resolve } from '$app/paths'
	import { page } from '$app/state'
	import { Badge } from '#lib/components/ui/badge/index.js'
	import { Button } from '#lib/components/ui/button/index.js'
	import {
		handleMenuClick,
		isMenuInternal,
		isSectionRegular,
		MENU_SECTIONS,
	} from '#lib/constants/menuItems.js'
	import { m } from '#lib/paraglide/messages.js'
	import { updateGetListedDialog } from '#lib/utils/dialogs.svelte.js'
	import { phg } from '#lib/utils/posthog.js'
</script>

<footer
	class="border-border/50 mt-auto flex items-center justify-between gap-3 border-t py-6 sm:border-t-0 sm:py-10"
>
	<nav class="mx-auto flex w-full flex-col gap-10 px-3 xl:container">
		<div class="xs:flex-row xs:items-center flex flex-col items-start justify-between gap-4">
			<a
				class="text-branding-gradient xs:text-2xl text-xl font-bold"
				href={resolve('/(marketing)')}
			>
				Chainspect
			</a>

			<Button
				onclick={() => {
					updateGetListedDialog({ open: true })
					phg.capture('get_listed_dialog_open')
				}}
				size="sm"
				variant="outline"
			>
				{m.menu_get_listed_long()}
			</Button>
		</div>

		<ul class="grid grid-cols-2 gap-x-1 gap-y-10 px-1 sm:grid-cols-4 md:gap-8">
			{#each MENU_SECTIONS.filter(s => isSectionRegular(s)) as section (section.text)}
				<li>
					<p class="text-sm font-semibold">{section.text}</p>

					<ul class="xs:mt-4 xs:gap-4 text-muted-foreground mt-3 flex flex-col gap-3 text-xs">
						{#each section.items as item (item.text)}
							<li>
								<a
									class={cn('hover:text-foreground', {
										'flex items-center justify-start gap-1.5': item.new,
									})}
									onclick={e => handleMenuClick(e, section, item, page.url.pathname, 'footer')}
									{...isMenuInternal(item)
										? { href: resolve(item.route) }
										: {
												href: item.href,
												rel: 'external noopener noreferrer',
												target: '_blank',
											}}
								>
									{item.text}

									{#if item.new}
										<Badge class="font-bold uppercase" size="4xs" variant="brand">New</Badge>
									{/if}
								</a>
							</li>
						{/each}
					</ul>
				</li>
			{/each}
		</ul>
	</nav>
</footer>
